// extracted by mini-css-extract-plugin
export default {"table":"styles_table__ExRZ0","table_header":"styles_table_header__ZxT2P","icon":"styles_icon__ez8co"};